'use client'

import { PdpImageLinkWrapper } from 'product-card/components/shared/ProductImage/PdpImageLinkWrapper/PdpImageLinkWrapper'
import { ProductImageSlideshow } from 'product-card/components/shared/ProductImage/ProductImageSlideshow/ProductImageSlideshow'
import { SingleProductImage } from 'product-card/components/shared/ProductImage/SingleProductImage/SingleProductImage'
import { useProductCardConsumerLayoutContext } from 'product-card/hooks/useProductCardConsumerLayoutContext'
import { useShowAsFeatured } from 'product-card/hooks/useShowAsFeatured/useShowAsFeatured'
import { useSortedProductImages } from 'product-card/hooks/useSortedProductImages/useSortedProductImages'
import { ImageDisplayType } from 'product-card/types'
import { EmptyImage } from './EmptyImage/EmptyImage'

export const ProductImage = () => {
	const sortedImages = useSortedProductImages()
	const showAsFeatured = useShowAsFeatured()

	const { shouldRenderSlider } = useProductCardConsumerLayoutContext()

	const imageDisplayType =
		sortedImages.length === 1 || !shouldRenderSlider
			? ImageDisplayType.Single
			: ImageDisplayType.Slider

	const [firstImage] = sortedImages

	if (!firstImage) {
		return (
			<PdpImageLinkWrapper
				imageDisplayType={ImageDisplayType.Single}
				isSEORelevant
			>
				<EmptyImage isTwoColumnSize={showAsFeatured} />
			</PdpImageLinkWrapper>
		)
	}

	return imageDisplayType === ImageDisplayType.Single ? (
		<SingleProductImage image={firstImage} />
	) : (
		<ProductImageSlideshow images={sortedImages} />
	)
}
